import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, SlidersHorizontal } from "lucide-react";
import { api } from "@/lib/api";
import ItemCard from "@/components/ItemCard";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Skeleton } from "@/components/ui/skeleton";

export default function Feed() {
  const [searchParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("Tutte");
  const [city, setCity] = useState(searchParams.get("city") || "");
  const [q, setQ] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (category && category !== "Tutte") params.category = category;
      if (city) params.city = city;
      if (q) params.q = q;
      const { data } = await api.get("/listings", { params });
      setItems(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { api.get("/categories").then(({ data }) => setCategories(data)); }, []);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [category]);

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-head font-extrabold text-3xl sm:text-4xl tracking-tight">Esplora gli annunci</h1>
        <p className="text-muted-foreground mt-2">Oggetti gratis da ritirare nella tua zona.</p>
      </div>

      <div className="rounded-2xl bg-card border border-border/60 tactile-shadow p-4 mb-8 flex flex-col md:flex-row gap-3">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="flex-1 flex gap-3">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca oggetti..." data-testid="search-input" className="pl-9 h-11 rounded-xl" />
          </div>
          <Input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Città" data-testid="city-input" className="h-11 rounded-xl w-32 md:w-40" />
          <Button type="submit" data-testid="search-btn" className="h-11 rounded-xl px-5"><SlidersHorizontal className="h-4 w-4" /></Button>
        </form>
        <Select value={category} onValueChange={setCategory}>
          <SelectTrigger className="h-11 rounded-xl md:w-48" data-testid="category-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="Tutte">Tutte le categorie</SelectItem>
            {categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-72 rounded-2xl" />)}
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-20 text-muted-foreground" data-testid="empty-feed">
          <p className="text-lg">Nessun oggetto trovato.</p>
          <p className="text-sm mt-1">Prova a cambiare i filtri o sii il primo a donare!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="feed-grid">
          {items.map((it, i) => <ItemCard key={it.id} item={it} index={i} />)}
        </div>
      )}
    </div>
  );
}
